import $ from '@rm/jquery';
import Vue from 'vue';
import Scale from '../../common/scale';
import WidgetClass from '../widget';
import RmFooter from '../../../components/common/rm-footer.vue';

const rmFooter = WidgetClass.extend({
  ignoreScale: true,

  render: function() {
    this.makeBox('widget-rm-footer');

    const rmFooterVue = Vue.extend(RmFooter);

    this.vue = new rmFooterVue({
      el: $('<div>')
        .appendTo(this.$el)
        .get(0),
    });

    this.fixScale();

    this.rendered = true;
    this.widgetIsLoaded();

    return this;
  },

  destroy: function() {
    this.vue && this.vue.$destroy();

    return WidgetClass.prototype.destroy.apply(this, arguments);
  },

  onPageResize: function() {
    WidgetClass.prototype.onPageResize.apply(this, arguments);
    this.fixScale();
  },

  fixScale: function() {
    const scale = Scale.getRatio();
    const isScaleEnabled = Scale.isAllowed();
    const isFullWidth = this.is_full_width;
    const unscale = 1 / scale;

    this.$el.css({
      transform: isScaleEnabled ? `scale(${unscale})` : undefined,
      marginTop: isScaleEnabled ? this.calcScaleFix(this.h, unscale) : undefined,
      marginLeft: isScaleEnabled && isFullWidth ? this.calcScaleFix(this.w, unscale) : undefined,
    });
  },

  calcScaleFix: (px, scale) => Math.ceil(((px - px * scale) / 2) * -1),
});

export default rmFooter;
